import React from 'react';
import { ReactNode } from 'react';
import './HeaderCell.scss';
import '../../../../shared/styles/Common.scss';

export interface HeaderCellProps {
  children: ReactNode | [ReactNode];
  align?: string;
  className?: string;
  onClick?: () => void;
}

export function HeaderCell({ children, align = '', className, onClick }: HeaderCellProps) {
  return (
    <td className={`header-cell-container unselectable ${className}`} onClick={onClick}>
      <div className={`header-cell-content ${align}`}>{children}</div>
    </td>
  );
}
